﻿(function (angular, location, ToyotaForms) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('formsChangeOwnership', ['$filter', '$q', 'API', function ($filter, $q, API) {
            formsChangeOwnershipController.$inject = ['$scope', '$element', 'AddressById', 'SmoothScrollTo', '$attrs'];
            function formsChangeOwnershipController($scope, $element, AddressById, SmoothScrollTo, $attrs) {

                function findOwnershipItem(ownershipValue) {
                    return ownershipValue && $scope.ownershipList.find(function (ownershipItem) {
                        return ownershipValue === ownershipItem.Value;
                    }) || null;
                }

                function repaint(optionalNewOwnershipValue) {
                    var ownershipValue = optionalNewOwnershipValue || $scope.fields.ownership;
                    var ownershipItem = findOwnershipItem(ownershipValue);

                    var oldShowDynamicContentPlaceholderSection = $scope.showDynamicContentPlaceholderSection;

                    $scope.showDynamicContentPlaceholderSection =
                        (ownershipItem ? ownershipItem.showDynamicContentPlaceholder : false) &&
                        !$scope.nextStepClicked;

                    $scope.showFormFieldSections = !$scope.showDynamicContentPlaceholderSection;
                    $scope.showAddress = $scope.showFormFieldSections;

                    if (oldShowDynamicContentPlaceholderSection !== $scope.showDynamicContentPlaceholderSection) {
                        if (!$scope.showDynamicContentPlaceholderSection) {
                            if (!$scope.nextStepClicked) {
                                SmoothScrollTo($element.find('[data-ty-forms-change-ownership-scroll-anchor-form-start]'));
                            } else {
                                SmoothScrollTo($element.find('[data-ty-forms-change-ownership-scroll-anchor-next-step-clicked]'));
                            }
                        } else {
                            SmoothScrollTo($element.find('[data-ty-forms-change-ownership-scroll-anchor-dynamic-content-placeholder]'));
                        }
                    }
                }

                $scope.init = function () {

                    $scope.fields = {
                        firstname: '',
                        lastname: '',
                        phone: '',
                        email: '',
                        address: '',
                        addressId: '',
                        ownership: '',
                        formName: '',
                        campaignCode: '',
                        vin: '',
                        registration: '',
                        state: ''
                    };

                    $scope.form = {
                        submitting: false,
                        completed: false,
                        success: false
                    };

                    $scope.showAddress = false;
                    $scope.showFormFieldSections = false;
                    $scope.nextStepClicked = false;

                    $scope.$on('address-tag-added', function (event, data) {

                        $scope.fields.addressId = data.data.info.search_result_id;

                        var addressTask = AddressById(data.data.info.search_result_id);

                        addressTask.then(function (data) {
                            $scope.fields.address = data;
                        });
                    });

                    $scope.$on('address-tag-removed', function () {
                        $scope.fields.address = '';
                    });

                    $scope.$watch('fields.ownership', function (value) {
                        if (value) {
                            $scope.nextStepClicked = false;
                            repaint(value);
                        }
                    });

                    $scope.handleNextStepClick = function () {
                        $scope.nextStepClicked = true;
                        repaint();
                    };
                };

                $scope.init();

                $scope.addressInValid = function () {

                    if ($scope.fields.addressId === '' && ($scope.wfm.address && $scope.wfm.address.$touched || $scope.wfm.$submitted)) {
                        return true;
                    }
                    return false;

                };

                $scope.addressValid = function () {

                    if ($scope.fields.addressId !== '' && $scope.wfm.address && $scope.wfm.address.$touched) {
                        return true;
                    }

                    return false;

                };

                $scope.ownershipInvalid = function (fieldId, isRequired) {
                    if (!isRequired) {
                        return false;
                    }

                    if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
                        return false;
                    }

                    return !$scope.wfm[fieldId].$valid;
                };

                $scope.ownershipValid = function (fieldId, isRequired) {
                    if (!isRequired) {
                        return false;
                    }

                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched) {
                        return false;
                    }

                    return $scope.wfm[fieldId].$valid;
                };

                $scope.toUpperCase = function (field) {
                    field = field.toUpperCase();

                    return field;
                };

                //passthrough function as Registration field in other forms (contact-us) require a differnt logic
                $scope.isRegistrationRequired = function (fieldId, isRequired) {
                    return isRequired;
                };

                $scope.isStateRequired = function (isRequired) {
                    return isRequired;
                };

                $scope.getData = function () {
                    var agreement;
                    if (angular.element('#terms-checkbox').length) {
                        agreement = $scope.fields.agreement;
                    }
                    else {
                        agreement = true;
                    }

                    $scope.toUpperCase($scope.fields.vin);
                    $scope.toUpperCase($scope.fields.registration);

                    var changeOwnershipData = {
                        FirstName: $scope.fields.firstname,
                        LastName: $scope.fields.lastname,
                        Email: $scope.fields.email,
                        Phone: $scope.fields.phone,
                        Vin: $scope.fields.vin,
                        Registration: $scope.fields.registration,
                        State: $scope.fields.state,
                        Agreement: agreement,
                        FormName: $scope.fields.formName,
                        CampaignCode: $scope.fields.campaignCode,
                        Ownership: $scope.fields.ownership
                    };

                    _.extend(changeOwnershipData, {
                        Address: {
                            street: $scope.fields.address.street_address || '',
                            suburb: $scope.fields.address.suburb || '',
                            postcode: $scope.fields.address.postcode || '',
                            state: $scope.fields.address.state || ''
                        }
                    });

                    return changeOwnershipData;
                };

                $scope.submit = function () {
                    $scope.form.submitting = true;

                    var url = $filter('formatArgs')(ToyotaForms.API.FormSubmission.ChangeOwnership);
                    var data = $scope.getData();

                    API.post(url, data)
                        .then(function (req) {
                            $scope.form.submitting = false;
                            $scope.form.completed = true;
                            if (req.data.isSuccessful) {
                                $scope.form.success = true;
                            } else {
                                $scope.form.success = false;
                            }

                            if ($scope.form.completed && $scope.form.success) {
                                $scope.$broadcast('form-success');
                                var successPageUrl = $attrs.formsChangeOwnershipSuccessPageRedirectUrl;
                                location.href = successPageUrl;
                            } else {
                                $scope.$broadcast('form-failure');
                            }
                        }, function () {
                            $scope.form.success = false;
                            $scope.$broadcast('form-server-error');
                        });
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsChangeOwnershipController,
                controllerAs: 'fc',
                bindToController: true,
                link: function (scope, element) {
                    element.find('[data-ty-forms-change-ownership-next-step]').on('click', function (e) {
                        e.preventDefault();
                        scope.$apply(scope.handleNextStepClick);
                    });
                }
            };
        }]);
})(window.angular, window.location, window.ToyotaForms);
